// extracted by mini-css-extract-plugin
export default {"selectedPaymentOption":"_2mQEP","removeSelectedPaymentOption":"_2_WMX","amountSpace":"_2KIfO"};